module.exports = __webpack_public_path__ + "static/media/golf-estate-8.148bb662.png";